module.exports = __webpack_public_path__ + "static/img/pop_bg_coupon_clip_type1.6d72e89b.png";